import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import ObservationList from './ObservationList';
import ImageModal from '../../modals/ImageModal';
import ObservationModal from '../../modals/ObservationModal';
import TrackModal from '../../modals/TrackModal';
import actions from '../../../store/appActions';

import './Observation.scss';
import AlertsList from './AlertsList';

class ObservationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.resizeStartX = 0;
    this.resizeStartWidth = 0;
    this.resizing = false;
  }

  componentWillUnmount() {
    this.teardownResultsResize();
  }

  startResultsResize = e => {
    if (this.props.isMobile || this.props.resultsCollapsed) return;
    e.preventDefault();
    e.stopPropagation();
    const panel = document.querySelector('.timeline');
    const panelRect = panel ? panel.getBoundingClientRect() : null;
    const startWidth =
      panelRect && Number.isFinite(panelRect.width)
        ? panelRect.width
        : Number(this.props.resultsPanelWidthPx) || 0;
    this.resizeStartX = e.clientX;
    this.resizeStartWidth = startWidth;
    this.resizing = true;
    document.body.classList.add('results-resizing');
    window.addEventListener('mousemove', this.handleResultsResizeMove);
    window.addEventListener('mouseup', this.handleResultsResizeEnd);
  };

  handleResultsResizeMove = e => {
    if (!this.resizing) return;
    const deltaX = this.resizeStartX - e.clientX;
    const nextWidth = this.resizeStartWidth + deltaX;
    if (this.props.onResultsPanelResize) {
      this.props.onResultsPanelResize(nextWidth);
    }
  };

  handleResultsResizeEnd = () => {
    this.teardownResultsResize();
  };

  teardownResultsResize = () => {
    if (!this.resizing) return;
    this.resizing = false;
    document.body.classList.remove('results-resizing');
    window.removeEventListener('mousemove', this.handleResultsResizeMove);
    window.removeEventListener('mouseup', this.handleResultsResizeEnd);
  };
  render() {
    const { ...props } = this.props;
    const showList = !this.props.resultsCollapsed;
    const showSelectedView = false;
    const baseClass = this.props.resultsCollapsed
      ? 'px-0 timeline timeline-collapsed border-right-0 h-100'
      : 'px-0 col-3 timeline border-right-0 h-100';
    const hasCustomDesktopWidth =
      !this.props.isMobile &&
      !this.props.resultsCollapsed &&
      Number.isFinite(Number(this.props.resultsPanelWidthPx));
    const panelStyle = hasCustomDesktopWidth
      ? {
          width: `${this.props.resultsPanelWidthPx}px`,
          minWidth: `${this.props.resultsResizeMinPx || 280}px`,
          maxWidth: `${this.props.resultsResizeMaxPx || 640}px`,
          flex: `0 0 ${this.props.resultsPanelWidthPx}px`
        }
      : undefined;
    const panelClassName =
      baseClass +
      (this.props.isMobile ? ' mobile-pane' : '') +
      (this.props.isMobile && !this.props.mobileActive
        ? ' mobile-pane-hidden'
        : '');

    return (
      <div className={panelClassName} style={panelStyle}>
        {!this.props.isMobile && (
          <button
            type="button"
            className={`results-panel-toggle-handle ${
              this.props.resultsCollapsed ? 'is-collapsed' : ''
            }`}
            onClick={this.props.onToggleResultsPanel}
            aria-label={
              this.props.resultsCollapsed
                ? 'Open results panel'
                : 'Close results panel'
            }
            title={
              this.props.resultsCollapsed
                ? 'Open results panel'
                : 'Close results panel'
            }
          >
            <span className="material-icons" aria-hidden="true">
              {this.props.resultsCollapsed ? 'chevron_left' : 'chevron_right'}
            </span>
          </button>
        )}
        {showList &&
          (props.alertTimelineOpen ? (
            <AlertsList resultsCollapsed={props.resultsCollapsed} />
          ) : (
            <ObservationList
              resultsCollapsed={props.resultsCollapsed}
              dataLoading={props.dataLoading}
              setTransientLoading={props.setTransientLoading}
              fetchAllData={props.fetchAllData}
              resetVersion={props.resetVersion}
              isMobile={props.isMobile}
            />
          ))}
        {showSelectedView && null}
        {!this.props.resultsCollapsed && (
          <>
            <ImageModal
              close={props.closeImageModal}
              open={props.imageModalOpen}
              data={props.imageModalData}
            />
            <ObservationModal
              close={props.closeObservationModal}
              open={props.observationModalOpen}
              data={props.observationModalData}
              openImage={props.openImageModal}
              labels={props.labels}
              selectedLanguage={props.selectedLanguage}
              currentUser={props.currentUser}
            />
            <TrackModal
              close={props.closeTrackModal}
              open={props.trackModalOpen}
              data={props.trackModalData}
              openImage={props.openImageModal}
            />
          </>
        )}
        {!this.props.isMobile && !this.props.resultsCollapsed && (
          <button
            type="button"
            className="results-resize-handle"
            aria-label="Resize results panel"
            title="Drag to resize results panel"
            onMouseDown={this.startResultsResize}
          />
        )}
      </div>
    );
  }
}

const getTimelineSelectedItem = state => state.timeline.selectedItem || {};
const getImageModalOpen = state => state.modals.imageModal.open || false;
const getImageModalData = state => state.modals.imageModal.data || {};
const getObservationModalOpen = state =>
  state.modals.observationModal.open || false;
const getObservationModalData = state =>
  state.modals.observationModal.data || {};
const getTrackModalOpen = state => state.modals.trackModal.open || false;
const getTrackModalData = state => state.modals.trackModal.data || {};

const getAlertTimelineOpen = state => state.ontology.alertTimelineOpen || false;
const getLabels = state => state.ontology.labels || [];
const getSelectedLanguage = state => state.ontology.selectedLanguage || 'en';
const getCurrentUser = state => state.user.currentUser || '';

const mapStateToProps = createSelector(
  getTimelineSelectedItem,
  getImageModalOpen,
  getImageModalData,
  getObservationModalOpen,
  getObservationModalData,
  getTrackModalOpen,
  getTrackModalData,
  getAlertTimelineOpen,
  getLabels,
  getSelectedLanguage,
  getCurrentUser,
  (
    timelineSelectedItem,
    imageModalOpen,
    imageModalData,
    observationModalOpen,
    observationModalData,
    trackModalOpen,
    trackModalData,
    alertTimelineOpen,
    labels,
    selectedLanguage,
    currentUser
  ) => ({
    timelineSelectedItem,
    imageModalOpen,
    imageModalData,
    observationModalOpen,
    observationModalData,
    trackModalOpen,
    trackModalData,
    alertTimelineOpen,
    labels,
    selectedLanguage,
    currentUser
  })
);

const mapDispatchToProps = {
  openImageModal: actions.modals.openImageModal,
  closeImageModal: actions.modals.closeImageModal,
  openObservationModal: actions.modals.openObservationModal,
  closeObservationModal: actions.modals.closeObservationModal,
  openTrackModal: actions.modals.openTrackModal,
  closeTrackModal: actions.modals.closeTrackModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ObservationComponent);
